export default __webpack_public_path__ + "static/media/bridgement.15bb17f8.svg";